<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>
              {{ `${this.$t("members.view.title")}` }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mr-3" color="secondary" :to="'/societyadmin/house/edit/'+member.id" v-if="member.status == 1">
              <v-icon small left>
                mdi-pencil
              </v-icon>
              Edit
            </v-btn>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("members.view.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10 text--primary">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="4">
                  <v-avatar
                    size="250"
                    v-if="member && member.profile_url != null"
                    tile
                    class="cursor-pointer ml-3 rounded-xl"
                  >
                    <v-img
                      :src="API_BASE_URL + '/uploads/' + member.profile_url"
                      :alt="member.name"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                  <v-avatar
                    v-else
                    color="grey"
                    class="white--text cursor-pointer ml-3 rounded-xl text-h3"
                    size="250"
                    tile
                  >
                    <span>{{ member.name.charAt(0) }}</span>
                  </v-avatar>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="8">
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("members.view.headers.name")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ member.name }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("members.view.headers.email")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ member.email ? member.email : "N/A" }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("members.view.headers.business")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ member.business ? member.business : "N/A" }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("members.view.headers.house_number")}` }}
                        :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ member.house_number }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("members.view.headers.mobile_no")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ member.country_code }} {{ member.mobile_no }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        v-if="member.status == 0"
                        color="success"
                        class="mr-5"
                        @click="confirmacceptMemeberRequest(member.id)"
                      >
                        <v-icon left>
                          mdi-check-bold
                        </v-icon>
                        Accept
                      </v-btn>
                      <v-btn
                        v-if="member.status == 0"
                        class="red darken-2 white--text"
                        @click="confirmrejectMemeberRequest(member.id)"
                      >
                        <v-icon left>
                          mdi-close-thick
                        </v-icon>
                        Reject
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="AcceptDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Confirm!!
        </v-card-title>
        <v-card-text class="mt-2">Are you sure want to Approve? </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="acceptMemeberRequest(accept_id)">
            yes
          </v-btn>
          <v-btn color="primary" text @click="closeDialog"> No </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="RejectDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Confirm!!
        </v-card-title>
        <v-card-text class="mt-2">Are you sure want to Reject? </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="rejectMemberRequest(reject_id)">
            yes
          </v-btn>
          <v-btn color="primary" text @click="closeDialog"> No </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
// import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      member: {
        name: "",
        email: "",
        business: "",
        house_number: "",
        mobile_no: "",
      },
      AcceptDialog: false,
      RejectDialog: false,
      accept_id: null,
      reject_id: null,
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getMemberDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/members/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            _self.member = data.member;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    confirmacceptMemeberRequest(id) {
      (this.AcceptDialog = true), (this.accept_id = id);
    },
    confirmrejectMemeberRequest(id) {
      (this.RejectDialog = true), (this.reject_id = id);
    },
    closeDialog() {
      this.AcceptDialog = false;
      this.RejectDialog = false;
      this.accept_id = null;
      this.reject_id = null;
    },
    acceptMemeberRequest(id) {
      let _self = this;
      _self.$axios
        .post("societyadmin/members/request/accept/" + id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.closeDialog();
            this.$router.push({ name: 'societyadminHouseRequest' });

            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    rejectMemberRequest(id) {
      let _self = this;

      _self.$axios
        .post("societyadmin/members/request/reject/" + id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.closeDialog();
            this.$router.push({ name: 'societyadminHouseRequest' });

            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getMemberDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>
